import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef } from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';
import InputFieldOutline from '../InputFieldOutline';
import s from './TextAreaInputField.scss';
/**
 * Our standard, plaintext `<textarea />` input.
 *
 * Allows indication of success or error via `validationResult`.
 */ const TextAreaInputField = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, isRequired, validationResult, areaFooter, disabled } = _param, rest = _object_without_properties(_param, [
        "className",
        "isRequired",
        "validationResult",
        "areaFooter",
        "disabled"
    ]);
    const localTextAreaRef = useRef(null);
    return /*#__PURE__*/ React.createElement(InputFieldOutline, {
        className: c(s['root'], className),
        outlineStyle: disabled ? 'disabled' : validationResult,
        onClick: ()=>localTextAreaRef.current && localTextAreaRef.current.focus()
    }, /*#__PURE__*/ React.createElement("textarea", _object_spread({
        required: isRequired,
        className: s['input'],
        disabled: disabled,
        ref: (node)=>{
            if (isFunction(ref)) {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
            localTextAreaRef.current = node;
        }
    }, rest)), areaFooter && /*#__PURE__*/ React.createElement("div", {
        className: s['footer-divider'],
        "aria-hidden": "true"
    }), areaFooter && /*#__PURE__*/ React.createElement("div", {
        className: s['footer']
    }, areaFooter));
});
TextAreaInputField.displayName = 'TextAreaInputField';
export default TextAreaInputField;

//# sourceMappingURL=TextAreaInputField.js.map